import { ReactElement } from 'react'
import { ITableInfinite } from 'components/table/infinite/InfiniteTable.interfaces'
import { FacturXReadyTestResult } from '@Arti-zen/package-backoffice'
import { Link } from 'react-router-dom'
import { pages } from 'navigation/pages'
import { Theme } from 'theme/theme'
import { ArtisanWithEfacture } from './EinvoicingArtisansCtrl'

import InterestLevelContent from './InterestLevelContent'
import IsFacturXReadyContent from './IsFacturXReadyContent'
import CopyToClipboard from './CopyToClipboard'

export const FacturXReadyTestResultColor: Record<FacturXReadyTestResult, string> = {
  [FacturXReadyTestResult.MissingInfos]: '#000000',
  [FacturXReadyTestResult.PdpAccountToCreate]: '#1a6ccf',
  [FacturXReadyTestResult.PdpAccountInError]: '#42dbfa', // visite
  [FacturXReadyTestResult.PdpAccountInReview]: '#fea500',
  [FacturXReadyTestResult.PdpAccountFailed]: '#fe0101',
  [FacturXReadyTestResult.PdpAccountReady]: '#22C55E',
}

export const definitionFields = ({
  setDialogContent,
  updateEfactureArtisanList,
}: {
  setDialogContent: (content: ReactElement | null) => void
  updateEfactureArtisanList: (companyId: number, changes: any) => Promise<void>
}): ITableInfinite<ArtisanWithEfacture>['definitionFields'] => {
  return [
    {
      indexName: 'id',
      label: 'Company Id',
      format: ({ id }) => (
        <Link to={pages.connected.artisan.profile.navigate(id)} target="_blank">
          {id}
        </Link>
      ),
    },
    {
      indexName: 'email',
      label: 'Email',
      format: ({ email }) => <CopyToClipboard text={email} />,
    },
    {
      indexName: 'companyName',
      label: 'Nom entreprise',
      format: ({ companyName, legalName }) => companyName || legalName,
      styles: ({ companyName, legalName }) => checkStyles(!!companyName || !!legalName),
      onClick: ({ companyName, legalName }) => {
        copyToClipboard(companyName || legalName)
      },
    },
    {
      indexName: 'phone',
      label: 'Téléphone',
      format: ({ phone, mobile }) => <CopyToClipboard text={phone || mobile} />,
    },
    {
      indexName: 'isFacturXReady',
      label: 'E-facture ready',
      format: ({ isFacturXReady }) => isFacturXReady.state,
      styles: ({ isFacturXReady }) => ({
        backgroundColor: FacturXReadyTestResultColor[isFacturXReady.state],
        color: 'white',
        fontWeight: 'bold',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
      }),
      onClick: (artisan) => setDialogContent(<IsFacturXReadyContent artisan={artisan} />),
    },
    {
      indexName: 'interestLevel',
      label: 'Intérêt',
      format: ({ interestLevel }) => interestLevel,
      onClick: (artisan) =>
        setDialogContent(
          <InterestLevelContent
            artisan={artisan}
            updateEfactureArtisanList={updateEfactureArtisanList}
            close={() => setDialogContent(null)}
          />
        ),
    },
    {
      indexName: 'reason',
      label: 'Raison',
      format: ({ reason }) => reason,
      onClick: (artisan) =>
        setDialogContent(
          <InterestLevelContent
            artisan={artisan}
            updateEfactureArtisanList={updateEfactureArtisanList}
            close={() => setDialogContent(null)}
          />
        ),
    },
    {
      indexName: 'comment',
      label: 'Commentaire',
      format: ({ comment }) => comment,
      onClick: (artisan) =>
        setDialogContent(
          <InterestLevelContent
            artisan={artisan}
            updateEfactureArtisanList={updateEfactureArtisanList}
            close={() => setDialogContent(null)}
          />
        ),
    },
  ]
}

const checkStyles = (isOk: boolean, notRequired?: boolean) => ({
  width: '100%',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
  backgroundColor: isOk ? Theme.colors.greenArtizen : notRequired ? Theme.colors.greyLight : 'red',
  color: 'white',
  fontWeight: 'bold',
})

const copyToClipboard = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text)
  } catch (err) {
    console.error('Erreur de copie', err)
  }
}
